import { render, staticRenderFns } from "./CommentMgt.vue?vue&type=template&id=4abe5e73&scoped=true&"
import script from "./CommentMgt.vue?vue&type=script&lang=js&"
export * from "./CommentMgt.vue?vue&type=script&lang=js&"
import style0 from "./CommentMgt.vue?vue&type=style&index=0&id=4abe5e73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe5e73",
  null
  
)

export default component.exports